export { default as Logomarca } from './logomarca_padrao.png';
